export { IMGSETTINGS } from '../theme'

export const imagekitUrl = (src?: string | null, settings?: string) => {
  /**
   * Takes an image path, which should have the form
   * `appname/ModelName/name.jpg` and returns the full URL for imagekit.
   *
   */
  if (!src) {
    return ''
  }
  if (src.indexOf('data:') >= 0) {
    return src
  }
  if (src.indexOf('blob:') >= 0) {
    return src
  }

  const imagekitPath = process.env.RAZZLE_IMAGEKIT_PATH
  // clean spaces in links
  let result = src.replace(/ /g, '%20')
  if (result.startsWith('https://s3.amazonaws.com/artshare-prod-data/')) {
    result = result.replace('https://s3.amazonaws.com/artshare-prod-data/', '')
  }
  if (
    result.startsWith(
      'https://s3-ap-southeast-1.amazonaws.com/artshare-prod-data/media/'
    )
  ) {
    result = result.replace(
      'https://s3-ap-southeast-1.amazonaws.com/artshare-prod-data/media/',
      ''
    )
  }
  if (!result.startsWith('http')) {
    result = `${imagekitPath}${result}`
  }
  if (!!settings) {
    result += settings
  }
  return result
}
